module.exports = __webpack_public_path__ + "static/media/iconv3.ce356795.png";